import React from 'react';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import {getUsefulDateWithYear, getUsefulDate} from '../../common/utils';
import {formatCredits, formatPoints} from '../../common/basket';
import {translate} from '../../i18n/translate';

class StoreCartDeliveryDate extends React.Component {
    onChangeDate = (pickupSite) => {
        window.location.assign(location.pathname + "?p=" + pickupSite);
    };

    onChangeDateMobile = (event) => {
        this.onChangeDate(event.target.value)
    };

    renderDatesSelector = (deliveryDateStr, multiplePickupSitesDates) => {
        if(this.props.isXs){
            return (
                <select id="deliveryDateSelector" className="delivery-date-selector" onChange={this.onChangeDateMobile} defaultValue={deliveryDateStr}>
                    {multiplePickupSitesDates.map(date => {
                        return <option key={date.key} value={date.key}>{date.dateStr}</option>
                    })}
                </select>
            )
        }
        return (
            <DropdownButton name="deliveryDateSelector" className="delivery-date-selector" title={deliveryDateStr} onSelect={this.onChangeDate} id="deliveryDateSelector">
                {multiplePickupSitesDates.map(date => {
                    return <MenuItem eventKey={date.key} key={date.key}>{date.dateStr}</MenuItem>
                })}
            </DropdownButton>
        )
    };

    render() {
        const showPoints = (this.props.staticData || {}).showItemPoints && this.props.nextDeliveryDate;
        const credits = (this.props.remainingCredits && this.props.remainingCredits.credits) ? formatCredits(this.props.remainingCredits.credits) : 0;
        const remainingBalanceAsCredits = this.props.remainingBalanceAsCredits;
        const enableRecurringLink = this.props.enableRecurringLink;
        const deliveryDateStr = !this.props.orderDate ? (this.props.nextDeliveryDate ? getUsefulDate(this.props.nextDeliveryDate) : '') : getUsefulDateWithYear(this.props.orderDate);
        const multiplePickupSitesDates = [];
        for (const pickupSiteDate in this.props.multiplePickupSitesDates){
            if (this.props.multiplePickupSitesDates.hasOwnProperty(pickupSiteDate))
                multiplePickupSitesDates.push({key:pickupSiteDate, date: this.props.multiplePickupSitesDates[pickupSiteDate], dateStr: getUsefulDate(this.props.multiplePickupSitesDates[pickupSiteDate])});
        }
        const hasMultipleDeliveryDates = multiplePickupSitesDates.length > 1;
        const missingPoints = showPoints ? (this.props.staticData || {}).minimumPerOrder - this.props.totals.points : 0;

        return (
            <div className="order-summary-delivery" id="orderSummaryDelivery">
                <i className="truck-icon"/>
                <div className={"delivery-title" + (hasMultipleDeliveryDates && this.props.isXs ? " multiple-dates" : "")}>
                    <div className="delivery-date-title">{translate('Delivery')}: </div>
                    <div className="delivery-date">
                        {hasMultipleDeliveryDates ?
                            this.renderDatesSelector(deliveryDateStr, multiplePickupSitesDates.sort((a,b) => a.date > b.date))
                            :
                            deliveryDateStr}
                    </div>
                    {
                        enableRecurringLink ?
                            <div className={"pull-right update-recurring-link" + (!this.props.isCheckoutScreen?"":" checkout")}
                                 onClick={this.props.onClickUpdateRecurring}>{(!this.props.isCheckoutScreen?"Update":"View") + " Recurring"}</div>
                            : undefined
                    }
                </div>
                {missingPoints > 0 &&
                    <div className="remaining-credits">Add {formatPoints(missingPoints)} p. to Checkout</div>
                }
                {!showPoints && this.props.remainingCredits && this.props.remainingCredits.show ?
                    <div className="remaining-credits">{(remainingBalanceAsCredits > 0 ? ("Balance: " + formatCredits(remainingBalanceAsCredits) + " / ") : "") + this.props.creditItemLabel + ": " + credits}</div>
                    : undefined
                }
                <hr className="summary-item-divider"/>
            </div>
        )
    }
}

export default StoreCartDeliveryDate;


// WEBPACK FOOTER //
// ./src/components/store/StoreCartDeliveryDate.js